import { CardFlip } from "../../CardFlip/CardFlip";
import { CardProjectsBack } from "./CardProjectsBack/CardProjectsBack";
import { CardProjectsFront } from "./CardProjectsFront/CardProjectsFront";

import "./cardProjects.scss";
import { Project } from "./Project/Project";
import { useState } from "react";

interface ICardProjects {
  image: string;
  projectName: string;
  shortDescription: string;
}

export const CardProjects = ({
  image,
  projectName,
  shortDescription
}: ICardProjects) => {
  const [openProject, setOpenProject] = useState<boolean>(false);
  return (
    <CardFlip
      className='card-projects my-4'
      cardFlipFront={<CardProjectsFront image={image} />}
      cardFlipBack={
        <CardProjectsBack
          projectName={projectName}
          shortDescription={shortDescription}
        />
      }
      onClick={() => setOpenProject(!openProject)}
      openChildren={openProject}>
      <Project
        isOpen={openProject}
        onClose={() => setOpenProject(false)}
        name={projectName}
      />
    </CardFlip>
  );
};
